/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Staking, StakingInterface } from "../../contracts/Staking";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "ActivityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "stakeIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isSAVRToken",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "stakeIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "profit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isSAVRToken",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "superStakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakedSuperPlan",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
    ],
    name: "StakingPlanCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Subscribed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newApr",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "SuperAprUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "superStakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "profit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "SuperClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "superStakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "SuperPlanActivityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "superStakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
    ],
    name: "SuperStakingPlanCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "superStakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "SuperWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "BASE_POINTS_DIVIDER",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_STAKE_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TIME_STEP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "subscriptionCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "subscriptionDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isSuperPowered",
        type: "bool",
      },
    ],
    name: "addStakingPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
    ],
    name: "addSuperStakingPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "calculateStakeProfit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
    ],
    name: "claimSuperPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isSAVRToken",
        type: "bool",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
    ],
    name: "depositSuperPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "extraAprPowerC",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isSAVRToken",
        type: "bool",
      },
    ],
    name: "extract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "stakeId",
        type: "uint256",
      },
    ],
    name: "getAvailableStakeReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getAvailableSuperStakeReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isSAVRToken",
        type: "bool",
      },
    ],
    name: "getAvailableTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakingPlans",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stakingPlanId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isSuperPowered",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "subscriptionCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "subscriptionDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "apr",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalStakesSavTokenNo",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalStakesSavrTokenNo",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalStakedSavToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalStakedSavrToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavTokenLocked",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavrTokenLocked",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalClaimed",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.StakingPlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getSuperStakingPlansForUser",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "stakingPlanId",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "isActive",
                type: "bool",
              },
              {
                internalType: "uint256",
                name: "totalStakesNo",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalStaked",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "currentLocked",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalClaimed",
                type: "uint256",
              },
            ],
            internalType: "struct IStaking.SuperStakingPlan",
            name: "plan",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "time",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "apr",
                type: "uint256",
              },
            ],
            internalType: "struct IStaking.AprChange",
            name: "apr",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "profit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "lastTimestamp",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalClaimed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalDeposited",
                type: "uint256",
              },
            ],
            internalType: "struct IStaking.SuperStake",
            name: "stake",
            type: "tuple",
          },
        ],
        internalType: "struct IStaking.SuperStakingPlanWithAprAndStake[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserPlanInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavTokenStaked",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavrTokenStaked",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isSubscribed",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "subscribedTill",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.UserStakingInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserPlansInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavTokenStaked",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentSavrTokenStaked",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isSubscribed",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "subscribedTill",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.UserStakingInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserStakes",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timeStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timeEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "apr",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "profit",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isClaimed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isSAVRToken",
            type: "bool",
          },
        ],
        internalType: "struct IStaking.Stake[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserStakesWithRewards",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "timeStart",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "timeEnd",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "apr",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "profit",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "isClaimed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "isSAVRToken",
                type: "bool",
              },
            ],
            internalType: "struct IStaking.Stake",
            name: "stake",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.StakeWithRewardsInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserSuperPlanInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "profit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deposit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDeposited",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.SuperStake",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasAnySubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasSubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractManagerAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "renewPowerSubscriptionB",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakingPlans",
    outputs: [
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isSuperPowered",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "subscriptionCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "subscriptionDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStakesSavTokenNo",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStakesSavrTokenNo",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStakedSavToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStakedSavrToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentSavTokenLocked",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentSavrTokenLocked",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalClaimed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "subscribe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "superStakingPlans",
    outputs: [
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "totalStakesNo",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStaked",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentLocked",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalClaimed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalLockedTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_extraApr",
        type: "uint256",
      },
    ],
    name: "updateExtraAprPowerC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minLimit_",
        type: "uint256",
      },
    ],
    name: "updateMinStakeLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "apr",
        type: "uint256",
      },
    ],
    name: "updatePlanAPR",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "updatePlanActivity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
    ],
    name: "updatePlanDurationDays",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256",
      },
    ],
    name: "updatePlanSubscriptionCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "subscriptionDuration",
        type: "uint256",
      },
    ],
    name: "updatePlanSubscriptionPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newApr",
        type: "uint256",
      },
    ],
    name: "updateSuperPlanAPR",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "updateSuperPlanActivity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "step_",
        type: "uint256",
      },
    ],
    name: "updateTimeStep",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakeId",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "withdrawAllCompleted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "superPlanId",
        type: "uint256",
      },
    ],
    name: "withdrawSuperPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(overrides?: Overrides & { from?: string }): Promise<Staking> {
    return super.deploy(overrides || {}) as Promise<Staking>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  override connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
